import { render, staticRenderFns } from "./MethodPaymentV2.vue?vue&type=template&id=44e2be15&scoped=true"
import script from "./MethodPaymentV2.vue?vue&type=script&lang=js"
export * from "./MethodPaymentV2.vue?vue&type=script&lang=js"
import style0 from "./MethodPaymentV2.vue?vue&type=style&index=0&id=44e2be15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e2be15",
  null
  
)

export default component.exports